import Button from "./Button";
import React from "react";
import classNames from 'classnames';
import FileInput from "./FileInput";
import {get} from "../../utils/dotutils";

export default (props) => {
    let eligable = true;
    if (props.data && props.componentConfig) {
        if(props.componentConfig.import) {
            eligable = Object.keys(props.componentConfig.import).map((importer) => {
                if (props.componentConfig.import[importer].filter) {
                    const eligable = props.componentConfig.import[importer].filter.map((filter) => {
                        if (get(props.data, filter.field) == filter.value) {
                            return true;
                        }
                    }).find((f) => f === true);
                    if (eligable) {
                        return props.componentConfig.import[importer];
                    }
                } else {
                    return props.componentConfig.import[importer];
                }
            }).find((f) => f !== undefined && f !== null);
        }
    }
    return (
        <FileInput {...props}  disabled={props.disabled || !eligable}>
            {props.children || <Button color="default" block={true} disabled={props.disabled || !eligable}>Importálás</Button>}
        </FileInput>
    );
}